import { emailDocument } from './emailRendering';

export const safeSignatureHtml = html => new DOMParser().parseFromString(emailDocument(html, true), 'text/html').body.innerHTML;
export const signatureText = html => {
  const body = new DOMParser().parseFromString(safeSignatureHtml(html), 'text/html').body;
  body.querySelectorAll('br').forEach(node => node.replaceWith('\n'));
  body.querySelectorAll('p,div,li,tr').forEach(node => node.append('\n'));
  return body.textContent.trim();
};
export const textHtml = text => {
  const div = document.createElement('div');
  div.textContent = text || '';
  return div.innerHTML.replace(/\n/g, '<br>');
};
export function signatureDraftFields(draft, signature, email) {
  if (draft.signature_initialized || draft.command || draft.mode === 'gmail-draft') return {};
  const applies = signature?.enabled && signature.send_as_email?.toLowerCase() === email?.toLowerCase()
    && (draft.mode === 'reply' ? signature.apply_to_replies : signature.apply_to_new_messages);
  return {
    signature_initialized: true,
    signature_html: applies ? safeSignatureHtml(signature.signature_html) : '',
    signature_handling: applies ? 'already_included' : 'omit',
  };
}
// Keep the editable signature separate in local drafts; append exactly once when
// constructing either a send payload or a future Gmail draft-write payload.
export function signedDraftBody(draft) {
  const include = draft.signature_handling === 'already_included' && draft.signature_html;
  const signature = include ? safeSignatureHtml(draft.signature_html) : '';
  const text = signatureText(signature);
  const hasSignature = !!(text || /<img\b/i.test(signature));
  const handling = draft.signature_handling === 'already_included' && !hasSignature && draft.signature_initialized
    ? 'omit' : draft.signature_handling || 'auto';
  return {
    text_body: draft.text_body + (hasSignature ? `\n\n${text}` : ''),
    ...(draft.mode !== 'forward' && (draft.html_body || hasSignature) ? { html_body: safeSignatureHtml(draft.html_body || textHtml(draft.text_body)) + (hasSignature ? `<br><br>${signature}` : '') } : {}),
    signature_handling: handling,
  };
}
export function signatureSaveBody(form, current) {
  return {
    send_as_email: form.send_as_email,
    signature_html: safeSignatureHtml(form.signature_html),
    enabled: form.enabled, apply_to_new_messages: form.apply_to_new_messages,
    apply_to_replies: form.apply_to_replies, sync_to_gmail: form.sync_to_gmail,
    ...(current?.version != null ? { expected_version: current.version } : {}),
  };
}
